import ShiftDetailPage from '../shiftDetail.page';
import { useCallback, useState } from 'react';
import useSearchString from '../../../hooks/UrlParamsHandler/useSearchParams';
import classNames from 'classnames';
import { FavouriteIcon } from '@tymbe/ui-icons';
import { ShiftDetailHistory } from './ShiftDetailHistory/ShiftDetailHistory';
import feathersClient from '../../../apiClient';
import { useQuery } from 'react-query';
import { DeleteShiftModal } from './ModalDeleteShift';
import { DropDownMenuOption } from './ShiftDetail/DropDownMenu';
import { ShiftDetailHeader } from './ShiftDetailModal/ShiftDetailHeader';
import { ShiftDetailBreadcrumb } from './ShiftDetailModal/ShiftDetailBreadcrumb';

const ShiftDetailModal = () => {
  const [deleteShiftModal, setDeleteShiftModal] = useState(false);
  const [showHistory, setShowHistory] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchString();
  const shiftId = searchParams.get('shiftId') || undefined;

  const toggle = () => {
    setDeleteShiftModal((prev) => !prev);
  };

  const { data: shift } = useQuery(['shiftDetail', shiftId], async () => {
    if (!shiftId) return null;
    return feathersClient.service('shift').get(shiftId, {
      query: {
        $eager:
          '[application(withDeleted).[person.personData(attendanceRate)], manShift.[canceledApplication.[person.personData(attendanceRate)], activeApplication.[person.personData], perk], branchoffice.parent, shiftTemplate, perk, documentType, company]',
        $modify: 'withApplicationCounts',
        $appendJuniorProp: true,
      },
    });
  });

  const toggleShowHistory = () => {
    setShowHistory((prev) => !prev);
  };

  const onShiftDetailClose = useCallback(() => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete('shiftId');
    setSearchParams(newParams);
  }, [searchParams, setSearchParams]);

  const menuOptions: DropDownMenuOption[] = [
    {
      text: 'Upravit směnu',
      icon: <FavouriteIcon name="mode_edit" className="text-secondary-400 size-4" />,
      link: `/shift/${shiftId}`,
    },
    {
      text: 'Smazat směnu',
      icon: (
        <FavouriteIcon name="delete" className="text-secondary-400 size-4" />
      ),
      onClick: () => {
        setDeleteShiftModal(true);
      },
    },
    {
      text: 'Upravit pozici',
      icon: <FavouriteIcon name="work" className="text-secondary-400 size-4" />,
      link: `/company/${shift?.company_id}/shift-template/${shift?.shift_template_id}`,
    },
    {
      text: 'Historie',
      icon: <FavouriteIcon name="watch_later" className="text-secondary-400 size-4" />,
      onClick: () => {
        toggleShowHistory();
      },
    },
  ];

  return (
    <>
      <div
        className={classNames(
          'flex flex-col ty-shift-detail-area gap-4 max-h-full w-[396px] bg-bg p-6 rounded-lg drop-shadow-lg',
          { hidden: !shiftId }
        )}
      >
        <ShiftDetailHeader
          showHistory={showHistory}
          toggleShowHistory={toggleShowHistory}
          onClose={onShiftDetailClose}
          menuOptions={menuOptions}
          menuOptionsPosition="right"
        />

        {showHistory ? (
          <ShiftDetailHistory shiftId={shiftId!} />
        ) : (
          <>
            <ShiftDetailBreadcrumb shift={shift ?? undefined} />
            <hr className="h-px bg-secondary-100 border-0 -mx-6" />
            <ShiftDetailPage toggleShowHistory={toggleShowHistory} />
          </>
        )}
      </div>

      <DeleteShiftModal isOpen={deleteShiftModal} toggle={toggle} />
    </>
  );
};

export default ShiftDetailModal;
